













































import { Component, Watch } from "vue-property-decorator";
import WindowVue from "@/app/core/window/WindowVue";
import { Mixins } from "vue-mixin-decorator";
import VueEvent from "@/app/core/decorator/VueEvent";
import { CreateRoomInput, RoomInfoExtend } from "@/@types/socket";
import LanguageManager from "@/LanguageManager";
import LifeCycle from "@/app/core/decorator/LifeCycle";
import SocketFacade from "@/app/core/api/app-server/SocketFacade";
import BaseInput from "@/app/core/component/BaseInput.vue";
import InputPasswordComponent from "@/app/core/component/InputPasswordComponent.vue";
import BcdiceSystemInput from "@/app/basic/common/components/BcdiceSystemInput.vue";
import CtrlButton from "@/app/core/component/CtrlButton.vue";

@Component({
  components: {
    CtrlButton,
    BcdiceSystemInput,
    InputPasswordComponent,
    BaseInput
  }
})
export default class CreateNewRoomWindow extends Mixins<
  WindowVue<never, CreateRoomInput>
>(WindowVue) {
  private name: string = "";
  private password: string = "";
  /** 選択されているシステム */
  private system: string = "DiceBot";
  private url: string = SocketFacade.instance.connectInfo.bcdiceServer;
  private extendInfo: RoomInfoExtend = {
    visitable: true,
    isFitGrid: true,
    isViewDice: true,
    isViewCutIn: true,
    isDrawGridId: true,
    mapRotatable: true,
    isDrawGridLine: true,
    isShowStandImage: true,
    isShowRotateMarker: true,
    windowSettings: {
      chat: "free",
      resource: "free",
      initiative: "free",
      chatPalette: "free",
      counterRemocon: "free"
    }
  };

  @LifeCycle
  public async mounted() {
    await this.init();
    this.inputEnter(".base-area select", this.commit);
    this.inputEnter(".base-area input:not([type='button'])", this.commit);
  }

  @Watch("url")
  private onChangeUrl() {
    this.system = "DiceBot";
  }

  @VueEvent
  private async commit() {
    await this.finally({
      name: this.name || LanguageManager.instance.getText(""),
      bcdiceServer: this.url,
      system: this.system,
      roomPassword: this.password,
      extend: this.extendInfo
    });
  }

  @VueEvent
  private async rollback() {
    await this.finally();
  }

  private onMouseEnterUrl(isHover: boolean) {
    this.windowInfo.message = isHover
      ? LanguageManager.instance.getText("label.input-bcdice-url")
      : "";
  }
}
